import React from "react"
import styles from '../../css/gallery.module.css'
import Image from './Image'
import GalleryImage from '../../constants/gallery'

const Gallery = () => {
  return (
    <section className={styles.gallery}>
      <div className={styles.center}>
        {GalleryImage.map((item, index) => {
          return <Image key={index} picture={item} className={styles.pic}/>
        })}
      </div>
    </section>
  )
}

export default Gallery
